import { i18n } from '@/i18n'

const drawToolbar = {
  actions: {
    title: i18n.t('leaflet-v1.drawToolbar.actions.title'),
    text: i18n.t('leaflet-v1.drawToolbar.actions.text'),
  },
  finish: {
    title: i18n.t('leaflet-v1.drawToolbar.finish.title'),
    text: i18n.t('leaflet-v1.drawToolbar.finish.text'),
  },
  undo: {
    title: i18n.t('leaflet-v1.drawToolbar.undo.title'),
    text: i18n.t('leaflet-v1.drawToolbar.undo.text'),
  },
  buttons: {
    polygon: i18n.t('leaflet-v1.drawToolbar.buttons.polygon'),
    polyline: 'Draw a polyline',
    rectangle: i18n.t('leaflet-v1.drawToolbar.buttons.rectangle'),
    circle: 'Draw a circle',
    marker: 'Draw a marker',
    circlemarker: 'Draw a circlemarker',
  },
}

const drawHandlers = {
  polygon: {
    error: i18n.t('leaflet-v1.drawHandlers.polygon.error'),
    tooltip: {
      start: i18n.t('leaflet-v1.drawHandlers.polygon.tooltip.start'),
      cont: i18n.t('leaflet-v1.drawHandlers.polygon.tooltip.cont'),
      end: i18n.t('leaflet-v1.drawHandlers.polygon.tooltip.end'),
    },
  },
  circle: {
    tooltip: {
      start: 'Click and drag to draw circle.',
    },
    radius: 'Radius',
  },
  circlemarker: {
    tooltip: {
      start: 'Click map to place circle marker.',
    },
  },
  marker: {
    tooltip: {
      start: 'Click map to place marker.',
    },
  },
  polyline: {
    error: i18n.t('leaflet-v1.drawHandlers.polyline.error'),
    tooltip: {
      start: 'Click to start drawing line.',
      cont: 'Click to continue drawing line.',
      end: 'Click last point to finish line.',
    },
  },
  rectangle: {
    tooltip: {
      start: i18n.t('leaflet-v1.drawHandlers.rectangle.tooltip.start'),
    },
  },
  simpleshape: {
    tooltip: {
      end: i18n.t('leaflet-v1.drawHandlers.simpleshape.tooltip.end'),
    },
  },
}

const editToolbar = {
  actions: {
    save: {
      title: i18n.t('leaflet-v1.editToolbar.actions.save.title'),
      text: i18n.t('leaflet-v1.editToolbar.actions.save.text'),
    },
    cancel: {
      title: i18n.t('leaflet-v1.editToolbar.actions.cancel.title'),
      text: i18n.t('leaflet-v1.editToolbar.actions.cancel.text'),
    },
    clearAll: {
      title: i18n.t('leaflet-v1.editToolbar.actions.clearAll.title'),
      text: i18n.t('leaflet-v1.editToolbar.actions.clearAll.text'),
    },
  },
  buttons: {
    edit: i18n.t('leaflet-v1.editToolbar.buttons.edit'),
    editDisabled: i18n.t('leaflet-v1.editToolbar.buttons.editDisabled'),
    remove: i18n.t('leaflet-v1.editToolbar.buttons.remove'),
    removeDisabled: i18n.t('leaflet-v1.editToolbar.buttons.removeDisabled'),
  },
}

const editHandlers = {
  edit: {
    tooltip: {
      text: i18n.t('leaflet-v1.editHandlers.edit.tooltip.text'),
      subtext: i18n.t('leaflet-v1.editHandlers.edit.tooltip.subtext'),
    },
  },
  remove: {
    tooltip: {
      text: i18n.t('leaflet-v1.editHandlers.remove.tooltip.text'),
    },
  },
}

export default {
  draw: {
    toolbar: drawToolbar,
    handlers: drawHandlers,
  },
  edit: {
    toolbar: editToolbar,
    handlers: editHandlers,
  },
}
